module.exports = __webpack_public_path__ + "static/media/AngelOne_R_Logo_RGB.e53bfcd4.png";